<div class="inspect-panel-root" style="width: 560px; background-color: var(--dx-color-border);">
  <div class="panel-title">{{ containerName }}</div>
  <div class="logo-placeholder">
    <img *ngIf="container?.logoLink" [src]="container?.logoLink" alt="Logo" class="title-logo" />
  </div>

  <ng-container [ngSwitch]="context">
    <np-inspect-container-details-context
      *ngSwitchCase="'containerDetails'"
      [container]="container"
      [containerType]="containerType"
      (containerSaved)="containerSaved.emit($event)">
    </np-inspect-container-details-context>

    <np-inspect-container-details-context
      *ngSwitchCase="'exportContainerDetails'"
      [container]="container"
      [containerType]="containerType"
      (containerSaved)="containerSaved.emit($event)">
    </np-inspect-container-details-context>

    <np-inspect-container-catalog
      *ngSwitchCase="'containerCatalog'"
      [container]="container"
      [catalogId]="catalogId"
      (containerSaved)="containerSaved.emit($event)">
    </np-inspect-container-catalog>
  </ng-container>
</div>
